import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  keyword: "",
  loading: false,
  sortConfig: {
    key: "createdAt",
    direction: "ASC",
  },
  listBidang: [],
  listObjectCategory: [],
  listKeyProcess: [],
  listRiskStatus: [],
};

export const MasterData = createSlice({
  name: "masterData",
  initialState,
  reducers: {
    ChangeData: (state, action) => {
      state.data = action.payload;
    },
    ChangeKeyword: (state, action) => {
      state.keyword = action.payload;
    },
    ChangeLoading: (state, action) => {
      state.loading = action.payload;
    },
    ChangeSortConfig: (state, action) => {
      state.sortConfig = action.payload;
    },
    ChangeListBidang: (state, action) => {
      state.listBidang = action.payload;
    },
    ChangeObjectCategory: (state, action) => {
      state.listObjectCategory = action.payload;
    },
    ChangeKeyProcess: (state, action) => {
      state.listKeyProcess = action.payload;
    },
    ChangeRiskStatus: (state, action) => {
      state.listRiskStatus = action.payload;
    },
  },
});

export const {
  ChangeData,
  ChangeKeyword,
  ChangeLoading,
  ChangeSortConfig,
  ChangeListBidang,
  ChangeObjectCategory,
  ChangeKeyProcess,
  ChangeRiskStatus,
} = MasterData.actions;

export default MasterData.reducer;
